import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zone',
  templateUrl: './zone.component.html',
  styleUrls: ['./zone.component.scss']
})
export class ZoneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
